import React from 'react'
import { connect } from "react-redux";
import { NavLink } from 'react-router-dom'
import { Button } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import { Card } from "semantic-ui-react";
import DestroyModal from "../generics/DestroyModal";

class ConsultationRemindersListItem extends React.Component {

  render () {
    const {consultationReminder, view } = this.props
    const title = I18n.t(`api.forms.consultation_reminder.options.${consultationReminder.minutesNotice}`)

    return (
      <Card key={consultationReminder.id}>
        <Card.Content as={NavLink} to={Routes.consultation_reminder_path({ id: consultationReminder.id, _options: true})}>
          <Card.Header> {title} </Card.Header>
          <Card.Meta>{consultationReminder.emailTemplate?.subject}</Card.Meta>

          {view === 'admin' &&
           <Card.Description>
             <Icon style={{color: consultationReminder.scopeColor}} name="user"/> {consultationReminder.scopeName}
           </Card.Description>
          }
        </Card.Content>
        {!consultationReminder.readOnly &&
        <Card.Content extra>
          <DestroyModal easy
            handleDestroy={() => this.props.destroyEntity(consultationReminder)}
            trigger={(props) => { return(
              <Button color='red' size='mini' compact floated='right' inverted onClick={props.onClick}>
                <Icon name='trash'/> {I18n.t('components.consultation_reminders_list.destroy')}
              </Button>)
            }}>
            {I18n.t('components.consultation_reminders_list.destroy_warning')}
          </DestroyModal>
        </Card.Content>
        }
      </Card>)
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    view: state.view
  }
}

export default connect(mapStateToProps)(ConsultationRemindersListItem);
